var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconStar02 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF4600",
  d: "M7.683.761a.343.343 0 0 1 .634 0l1.719 4.133c.049.119.16.2.289.21l4.462.358a.343.343 0 0 1 .195.602l-3.4 2.912a.34.34 0 0 0-.11.34l1.039 4.354a.343.343 0 0 1-.512.373l-3.82-2.334a.34.34 0 0 0-.358 0l-3.82 2.334a.343.343 0 0 1-.512-.373l1.039-4.354a.34.34 0 0 0-.11-.34l-3.4-2.912a.343.343 0 0 1 .195-.602l4.462-.358a.34.34 0 0 0 .29-.21z"
})));
export default SvgIconStar02;